<template lang="html">
  <transition-group name="list-complete" class="box-layout-list-container" tag="div">
    <div v-for="outfit in filteredOutfits" :key="outfit.id" class="box-layout-list-child">
      <div class="box-layout-list-child-inner">
        <div class="title-row">
          <div>
            <div class="title-row--title">{{ outfit.title }}</div>
            <div class="title-row--date">{{ formatDate(outfit.created_at) }}</div>
          </div>

          <div>
            <a
              class="destroy-outfit-btn"
              @click.prevent="showRemoveOutfitModal(outfit.id)"
            >
              <i class="action-icon pe-7s-trash"></i>
            </a>
          </div>
        </div>
        <BoxLayoutListItem :outfit="outfit" />
      </div>
    </div>
  </transition-group>
</template>

<script>
import BoxLayoutListItem from "@/components/wardrobe/outfits/BoxLayoutListItem";
import CapsuleUtils from "@/utils/CapsuleUtils";
import { mapActions, mapGetters } from "vuex";

export default {
  created() {
    this.formatDate = CapsuleUtils.formatDate;
  },

  props: {
    outfits: Array,
  },

  components: {
    BoxLayoutListItem,
  },

  computed: {
    ...mapGetters(["currentUser"]),

    filteredOutfits() {
      return [...this.outfits].sort(
        (a, b) => new Date(b.created_at) - new Date(a.created_at)
      );
    },
  },

  methods: {
    ...mapActions(["destroyWardrobeOutfit"]),

    showRemoveOutfitModal(wardrobeOutfitId) {
      this.$nextTick(() => {
        this.$modal.show("confirm-remove-outfit", {
          wardrobeId: this.currentUser.wardrobe_id,
          wardrobeOutfitId: wardrobeOutfitId,
        });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/styles/_colour-palette.scss";
@import "~@/styles/_breakpoints.scss";

.destroy-outfit-btn {
  font-size: 1.4rem;
  padding: 5px 10px;
  margin-right: -10px;
  cursor: pointer;
  color: $grey2;

  &:hover {
    color: $alizarin;
  }
}

// -------------

.box-layout-list-container {
  --gap: 30px;
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  margin: calc(-1 * var(--gap)) 0 0 calc(-1 * var(--gap));
  width: calc(100% + var(--gap));
  justify-content: space-between;

  @include for-tablet-portrait-up {
    flex-direction: row;
  }

  @include for-desktop-up {
    --gap: 50px;
  }
}

.box-layout-list-container > * {
  margin: var(--gap) 0 0 var(--gap);
  margin-bottom: 30px;
}

.box-layout-list-child {
  display: flex;
  flex-direction: column;
  flex: 1 1 100%;
  max-width: 100%;
  transition: transform 1s;
  align-items: center;

  @include for-tablet-portrait-up {
    flex: 1 1 calc(50% - var(--gap));
    max-width: calc(50% - var(--gap) / 2);
  }

  .title-row {
    margin-bottom: 25px;
    margin-top: 0px;
    padding-left: 5px;
    display: flex;
    justify-content: space-between;

    .title-row--title {
      font-size: 1.1rem;
      font-weight: 500;
      color: grey1;
    }

    .title-row--date {
      font-size: 0.7rem;
      color: grey4;
      padding-left: 2px;

      &:first-letter {
        text-transform: capitalize;
      }
    }
  }
}

.box-layout-list-child-inner {
  display: flex;
  flex-direction: column;
  flex: 1 1 100%;
  padding: 15px;
  background-color: $grey8;
  border: 1px solid $grey5;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
}

.list-complete-enter, .list-complete-leave-to
/* .list-complete-leave-active for <2.1.8 */ {
  opacity: 0;
  transform: translateY(30px);
}
.list-complete-leave-active {
  position: absolute;
}
</style>



// WEBPACK FOOTER //
// src/components/wardrobe/outfits/BoxLayoutList.vue